import type { ProcessedFormComponent } from './types'

// Checks whether a rich-text HTML string (as emitted by TipTap) contains no visible text.
// We strip tags with a regex rather than DOMParser to avoid reinterpreting untrusted content
// as HTML. A false-negative (non-empty reported as empty) cannot occur: any unstripped tag
// fragment (e.g. `">text`) still contains non-whitespace characters.
export const isHtmlContentEmpty = (value: string): boolean => value.replace(/<[^>]*>/g, '').trim() === ''

export const isFieldEmpty = (component: ProcessedFormComponent | null, value: unknown): boolean => {
	if (!component) {
		return (
			value === null || value === undefined || value === false || (typeof value === 'string' && value.trim() === '')
		)
	}
	switch (component.name) {
		case '9boxrating':
			return value === null || value === undefined || value === 0
		case 'checkbox':
			return value === null || value === undefined || value === false
		case 'textarea':
			return value === null || value === undefined || (typeof value === 'string' && isHtmlContentEmpty(value))
		case 'externallink':
			return false
		case 'number':
		case 'rating':
			return value === null || value === undefined || value === '' || (typeof value === 'string' && value.trim() === '')
		default:
			return value === null || value === undefined || value === '' || (typeof value === 'string' && value.trim() === '')
	}
}
